const state= {
    equipModels: [],
    equipments:{
        items:[],
        total:0,
        pages: {
            limit: 100,
            page: 1,
            totalPage : 1,
            filter: {}
          },
    },
    equipmentLoading: {
        listing: false,
        category:false,
        import: false,
        generate_jobs: false
    },
    equipmentCategory:[],
    equipment : null,
    liftInspectionEvents: [],
    loadingEvent: false
};

const getters = {
    ListEquipModels : (state) => state.equipModels,
    equipments : (state) => state.equipments,
    equipmentLoading : (state) => state.equipmentLoading,
    equipmentCategory : (state) => state.equipmentCategory,
    equipment : (state) => state.equipment,
    liftInspectionEvents : (state) => state.liftInspectionEvents,
    loadingEvent : (state) => state.loadingEvent,
};

const actions = {
    async getEquipments({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoading', {key: "listing",val : true} );
            global.axios.get(`api/equipment`,{params:params})
                .then(response => {
                    response.data.data.pages = params
                    commit( 'setLoading', {key: "listing",val : false} );
                    commit( 'setItems', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async getEquipmentCategory({commit}, params){
        let id = params.id || 0;
        let  related_supplier =  params.related_supplier || false
        let  self =  params.self || null
        return new Promise (( resolve, reject ) => {
            commit( 'setLoading', {key: "category",val : true} );
            global.axios.get(`api/equipment/tree-structure/${id}`,{
                params : {
                    contract_id : params.contract_id,
                    related_supplier : related_supplier,
                    self: self,
                }
            })
                .then(response => {
                    commit( 'setLoading', {key: "category",val : false} );
                    //commit( 'setItems', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async deleteEquipment({commit}, ids){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/equipment`,{
                data:{
                    ids:ids
                }
            })
                .then(response => {
                    //commit( 'setGroup', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async createEquipment({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/equipment`, {
                method: "POST",
                data: params.equipment,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async updateEquipment({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/equipment/${params.equipment.id}`, {
                method: "PUT",
                data: params.equipment,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    commit('updateListEquipment',response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async saveEquipment({ commit }, params) {
        let api = `api/equipment`;
        let method = "PUT";
        let formData = null;
        if(!params.id) {
            method = "POST";
            formData = new FormData();

            for (const [key, value] of Object.entries(params)) {
                if(
                    (typeof value != 'object' && key != 'location_maps' && key != 'service_tags' && key != 'manufacturer_tags')
                    || key == 'custom_fields'
                ) {
                    formData.append(key, value || '');
                }
            }
            if(params.location_maps && params.location_maps.length > 0) {
                for( var i = 0; i < params.location_maps.length; i++ ){
                    let photo = params.location_maps[i];
                    formData.append('location_maps[' + i + ']', photo);
                }
            }
            
            if(params.service_tags && params.service_tags.length > 0) {
                for( var i = 0; i < params.service_tags.length; i++ ){
                    let photo = params.service_tags[i];
                    formData.append('service_tags[' + i + ']', photo);
                }
            }
            
            if(params.manufacturer_tags && params.manufacturer_tags.length > 0) {
                for( var i = 0; i < params.manufacturer_tags.length; i++ ){
                    let photo = params.manufacturer_tags[i];
                    formData.append('manufacturer_tags[' + i + ']', photo);
                }
            }
        } else {
            api += `/${params.id}`;
            params.location_maps = undefined;
            params.service_tags = undefined;
            params.manufacturer_tags = undefined;
            formData = params;
        }
        
        return new Promise((resolve, reject) => {
            global.axios(api, {
                method: method,
                data: formData,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        });
    },
    async getEquipment({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/equipment/${params}`, {
                method: "GET",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    commit('setEquipment', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    /*Equipment Categories*/
    async CreateEquipmentStructure({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/equipment/structure`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        commit('StatusController/setequipmentStructure',{ key : 'equipment', value : true }, { root: true });
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    async UpdateEquipmentStructure({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/equipment/structure/` + params.id, {
                method: "PUT",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    commit('StatusController/setequipmentStructure',{ key : 'equipment', value : true }, { root: true });
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    async DeleteEquipmentStructure({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/equipment/structure/` + params.id, {
                method: "DELETE",
                params: {
                    contract_id:   params.contract_id
                },
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    commit('StatusController/setequipmentStructure',{ key : 'equipment', value : true }, { root: true });
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    import({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('import',params.fileImport);
            formData.append('contract_id',params.id);
            commit( 'setLoading', {key:'import',val:true} );
            global.axios.post(`api/equipment/import`,formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    commit( 'setLoading', {key:'import',val:false} );
                    resolve( response );
                })
                .catch(error =>{
                    commit( 'setLoading', {key:'import',val:false} );
                    reject( error )
                } );
        });
    },
    async generateJobs({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit( 'setLoading', {key:'generate_jobs',val:true} );
            global.axios(`api/equipment/generate-jobs`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                commit( 'setLoading', {key:'generate_jobs',val:false} );
                resolve(response);
            })
            .catch(error => {
                commit( 'setLoading', {key:'generate_jobs',val:false} );
                reject(error)
            });
        });
    },
    async generateJobsCheckMaint({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/equipment/generate-jobs`, {
                method: "GET",
                params: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        });
    },

    /* Equipment Group Custom Field*/

    async updateCustomField({commit},params){

        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/structure/custom-field`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        commit('deleteItemEquipModels', params)
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    async getCustomFields({commit}, params){
        return new Promise (( resolve, reject ) => {

            global.axios(`/api/equipment/structure/custom-fields/`, {
                method: "GET",
                params: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },

    async updateAttachment({commit}, params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            for( var i = 0; i < params.data.photos.length; i++ ){
                let photo = params.data.photos[i];
                formData.append('photos[' + i + ']', photo);
            }
            formData.append('attachment_type', params.data.attachment_type);
            formData.append('ids', JSON.stringify(params.data.ids));
            global.axios(`/api/equipment/attachments/${params.id}`, {
                method: "POST",
                data: formData,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },

    // Asset Management
    async createAssetManagement({commit}, params){

        return new Promise (( resolve, reject ) => {
            global.axios(`/api/equipment/generate-jobs-asset-management`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },

    async checkScheduledJob({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/equipment/check-existing-schedule-job`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },

    async checkExpiredJobsRescheduling({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/equipment/check-expired-jobs-rescheduling`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },

    async exportAssetManagement({commit}, params){
        let request = params.tableRequest;
        request.is_equipment_schedule = params.is_equipment_schedule;
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/equipment/asset-management-export`, {
                method: "GET",
                params: request,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },

    //get Equipment Histories
    async getEquipmentHistories({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/equipment/histories`, {
                method: "GET",
                params: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },

    async statusEquipment({commit}, params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            for (const [key, value] of Object.entries(params.data)) {
                if(['location_maps','service_tags', 'manufacturer_tags'].includes(key)) {
                    if(value && value.length) {
                        for(let i = 0; i < value.length; i++) {
                            formData.append(`${key}[${i}]`, value[i]);
                        }
                    }
                } else {
                    let val = value !== null ? value : '';
                    if(typeof val == 'object') val = JSON.stringify(val);
                    if(typeof val == 'boolean' && val == false) val = '0';
                    formData.append(key, val);
                }
            }

            global.axios.post(`/api/equipment/${params.id}/status`, formData)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },

    async downloadReportLiftPerAge({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/equipment/report-lift-per-age`, {
                method: "POST",
                params: params,
                responseType: 'blob',
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },


    //get Value of Custom Field
    async getValueOfCustomField({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/equipment/custom-fields/get-value`, {
                method: "GET",
                params: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    
    // Lift Inspection Calendar
    async getCalendarView({ commit }, params) {
        commit( 'setLoadingEvent', true );
        return new Promise((resolve, reject) => {
            global.axios(`api/runsheet-calendar/calendar-view-lift-testing-schedule`, {
                method: "GET",
                params: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    commit( 'setLiftInspectionEvents', response.data.data );
                    commit( 'setLoadingEvent', false );
                    resolve(response.data.data);
                })
                .catch(error => {
                    commit( 'setLoadingEvent', false );
                    reject(error)
                });
        });
    },
    async getEquipmentsOfLiftInspectionCalendar({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/equipment/calendar`,{params:params})
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setItems (state,equipments) {
        equipments.pages.totalPage = Math.ceil(equipments.total / equipments.pages.limit );
        state.equipments.items = equipments.items;
        state.equipments.total = equipments.total;
        state.equipments.pages = equipments.pages;
    },
    setLoading (state,params) {
        if(params.key === "listing"){
            state.equipmentLoading.listing = params.val;
        }
        if(params.key === "category"){
            state.equipmentLoading.category = params.val;
        }
        if(params.key === "import"){
            state.equipmentLoading.import = params.val;
        }
        if(params.key === "generate_jobs"){
            state.equipmentLoading.generate_jobs = params.val;
        }
    },
    deleteItemEquipModels (state, params) {
        if(index_parent != -1) {
            let index_child = state.equipModels[index_parent].data.findIndex(item => item.id == params.id)

            if(index_child != -1) {
                state.equipModels[index_parent].data.splice(index_child, 1)
            }
        }
    },
    updateListEquipment (state,data) {
        state.equipments.items = state.equipments.items.map(item => item.id === data.id ? data : item)
    },
    setEquipment (state,data) {
        state.equipment = data
    },
    setLiftInspectionEvents (state,data) {
        state.liftInspectionEvents = data;
    },
    setLoadingEvent (state, data) {
        state.loadingEvent = data
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}